import { render, staticRenderFns } from "./ContractData.vue?vue&type=template&id=0ba3e466&scoped=true&"
import script from "./ContractData.vue?vue&type=script&lang=js&"
export * from "./ContractData.vue?vue&type=script&lang=js&"
import style0 from "./ContractData.vue?vue&type=style&index=0&id=0ba3e466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3e466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba3e466')) {
      api.createRecord('0ba3e466', component.options)
    } else {
      api.reload('0ba3e466', component.options)
    }
    module.hot.accept("./ContractData.vue?vue&type=template&id=0ba3e466&scoped=true&", function () {
      api.rerender('0ba3e466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/ContractData.vue"
export default component.exports